import { Component, Inject } from "@angular/core";
import { LicenseService } from "../../../services/LicenseService";
import { MD_DIALOG_DATA, MdDialogRef, MdSnackBar } from "@angular/material";
import { AdalService } from "../../../shared/adal.service";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AppLoaderService } from "../../../../services/app-loader/app-loader.service";

@Component({
    template:require('./extend-LZ30-trial-period.component.html'),
    styles:[require('./extend-LZ30-trial-period.component.css')],
    selector:'extend-LZ30-trial-period'
})
export class ExtendLZ30TrialPeriod{
    userDeviceDisplayDetail;
    SelectedDeviceDetail;
    LZ30ExtendTrialPeriodForm:FormGroup;
    dialogTitle='Extend Trial Period';
    errorMessage=''
    constructor(
        private licenseService:LicenseService,
        private dialogRef:MdDialogRef<ExtendLZ30TrialPeriod>,
        private adalService:AdalService,
        private router:Router,
        private formBuilder:FormBuilder,
        private snackBar:MdSnackBar,
        private appLoader:AppLoaderService,
        @Inject(MD_DIALOG_DATA) public dialogData:any,
    ){
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null)
            this.router.navigate(["login"]);
        }
        this.userDeviceDisplayDetail=dialogData.userDeviceDisplayData
        this.SelectedDeviceDetail=dialogData.SelectedDeviceDetail
        this.buildForm();
    }
    buildForm(){
        this.LZ30ExtendTrialPeriodForm=this.formBuilder.group({
            TrialMonth:['',Validators.required],
            Date:['',Validators.required]
        })
    }
    onSave(){
        let model={
            UpdatedBy:Number(localStorage.getItem('userid')),
            LZ30DeviceId:this.SelectedDeviceDetail.LZ30DeviceId,
            TrialMonth:this.LZ30ExtendTrialPeriodForm.value.TrialMonth,
            LZ30StartDate:this.LZ30ExtendTrialPeriodForm.value.Date
        }
        this.appLoader.open()
        this.licenseService.extendLZ30TrialPeriod(model).subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.userDeviceDisplayDetail=data.DataObject;
                this.appLoader.close()
                this.dialogRef.close(this.userDeviceDisplayDetail);
                this.snackBar.open("Trial period extended","",{
                    duration:1000
                })
                
            }
        })
    }
    onCancel(){
        this.dialogRef.close(this.userDeviceDisplayDetail);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/lz30/extend-LZ30-trial-period/extend-LZ30-trial-period.component.ts